import { render, staticRenderFns } from "./PopupShipLogList.vue?vue&type=template&id=6d61addd&scoped=true"
import script from "./PopupShipLogList.vue?vue&type=script&lang=js"
export * from "./PopupShipLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d61addd",
  null
  
)

export default component.exports